module.exports = __webpack_public_path__ + "static/img/redIcon.1f9652ae.png";